import { Agent, DEFAULT_ORGANIZATION_ID, Project } from '@moderepo/mode-internal-apis';
import { RitzMenuItemName, ProjectUIConfig } from '../../utils/ritzUIExtensionUtils';
import drawerMenuBackground from '../../assets/images/drawer_menu_background_2.jpg';
import { RouteHelper } from '../routes/RouteHelper';
import { RCRouteHelper } from './RCRouteHelper';
import { getOrganization } from '../app/App';



export enum RCMenuItemName {
    ROBOTS = 'Robots',
    ISSUES = 'Issues',
    MONITORS = 'Monitors',
}



/**
 * Return the default UI config for ALL RobotCloud type of project. This returns all the possible UI features that are available for Robot Cloud
 * type of projects.
 *
 * @param loggedInAgent
 * @param project
 */
export const getRCDefaultProjectUIConfig = (loggedInAgent: Agent | undefined, project: Project | undefined): ProjectUIConfig => {
    const routeHelper = RouteHelper.getInstance();
    const rcRouteHelper = RCRouteHelper.getInstance();
    const organization = getOrganization();

    return {
        drawerMenu: {
            appNameKey     : organization?.id === DEFAULT_ORGANIZATION_ID ? 'app.title_default' : 'app.title',
            projectLogo    : '',
            backgroundImage: drawerMenuBackground,
            menuItems      : [
                {
                    itemName: RitzMenuItemName.DASHBOARD,
                    disabled: project === undefined,
                    labelKey: 'drawer_menu.dashboard.label',
                    iconKey : 'home',
                    link    : project ? routeHelper.getProjectHomePageUrl(project.id) : '',
                },
                {
                    itemName: RCMenuItemName.ISSUES,
                    disabled: project === undefined,
                    labelKey: 'drawer_menu.issues.label',
                    iconKey : 'report',
                    link    : project ? rcRouteHelper.getIssuesPageUrl({ projectId: project.id }) : '',
                },
                {
                    itemName: RitzMenuItemName.MANAGE_DATA,
                    disabled: project === undefined,
                    labelKey: 'drawer_menu.manage_data.label',

                    iconKey     : 'construction',
                    selectable  : false,
                    subMenuItems: [
                        {
                            itemName: RitzMenuItemName.HOMES,
                            disabled: project === undefined,
                            labelKey: 'drawer_menu.homes.label',
                            iconKey : 'icons.home',
                            link    : project ? routeHelper.getHomesPageUrl(project.id) : undefined,
                        },
                        {
                            itemName: RitzMenuItemName.DEVICES,
                            disabled: project === undefined,
                            labelKey: 'drawer_menu.gateway.label',
                            iconKey : 'icons.gateway',
                            link    : project ? routeHelper.getProjectDevicesPageUrl(project.id) : '',
                        },
                        {
                            itemName: RitzMenuItemName.USERS,
                            disabled: project === undefined,
                            labelKey: 'drawer_menu.users.label',
                            iconKey : 'icons.user',
                            link    : project ? routeHelper.getUsersPageUrl(project.id) : '',
                        },
                        {
                            itemName: RCMenuItemName.ROBOTS,
                            disabled: project === undefined,
                            labelKey: 'drawer_menu.robots.label',
                            iconKey : 'mode-icon rc-logo',
                            link    : project ? rcRouteHelper.getRobotsPageUrl({ projectId: project.id }) : '',
                        },
                        {
                            itemName: RCMenuItemName.MONITORS,
                            disabled: project === undefined,
                            labelKey: 'drawer_menu.monitoring.label',
                            iconKey : 'visibility',
                            link    : project ? rcRouteHelper.getMonitoringPageUrl({ projectId: project.id }) : '',
                        },
                    ],
                },
                {
                    itemName: RitzMenuItemName.DOWNLOADS,
                    disabled: project === undefined,
                    labelKey: 'drawer_menu.ts_download_request_view.label',
                    iconKey : 'get_app',
                    link    : project ? routeHelper.getDownloadExportedDataPageUrl(project.id) : '',
                },
                {
                    itemName : RitzMenuItemName.ADMIN,
                    adminOnly: true,
                    disabled : project === undefined,
                    labelKey : 'drawer_menu.project_settings.label',
                    iconKey  : 'settings',
                    link     : project ? routeHelper.getAdminPageUrl({ projectId: project.id }) : '',
                },
            ],
        },
        projectDashboardPage: {
            components: [{
                compProps: {
                    spacing: 3,
                },
                gridItems: [{
                    compProps: {
                        xs: 12,
                    },
                    components: [{
                        componentName  : 'RCProjectStatisticsContainer',
                        routeParamProps: {
                            projectId: '{{projectId}}',
                        },
                        compProps: {
                        },
                    }],
                }, {
                    compProps: {
                        xs: 12,
                        md: 6,
                    },
                    components: [{
                        componentName  : 'RCIssuesContainer',
                        routeParamProps: {
                            projectId: '{{projectId}}',
                        },
                        compProps: {
                            className   : 'match-height',
                            itemsPerPage: 10,
                            hiddenFields: {
                                homeId         : true,
                                alertId        : true,
                                values         : true,
                                description    : true,
                                ticketLink     : true,
                                createdAgentId : true,
                                resolvedAgentId: true,
                                resolvedAt     : true,
                            },
                            filters: {
                                pageNumber: 0,
                                pageSize  : 10,
                                resolved  : false,
                            },
                        },
                    }],
                }, {
                    compProps: {
                        xs: 12,
                        md: 6,
                    },
                    components: [{
                        componentName  : 'RCIssueRobotsMapContainer',
                        routeParamProps: {
                            projectId: '{{projectId}}',
                        },
                        compProps: {
                            className: 'match-height',
                        },
                    }],
                }],
            }],
        },
    };
};
